import { render, staticRenderFns } from "./Reporting_FNDH.vue?vue&type=template&id=90d5022a"
import script from "./Reporting_FNDH.vue?vue&type=script&lang=js"
export * from "./Reporting_FNDH.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports